import RMOPendingAppointmentComponent from 'pages/AppointmentsPage/components/RMOPendingAppointmentComponent';
import React from 'react';
import "./DiscountApproval.scss";
import { useHistory } from 'react-router';


function DiscountApproval() {
  const history = useHistory();
  return (
    <div style={{ marginTop: "20px", paddingBottom: '50px' }} className="Request-wrapper">
      <div style={{ display: "flex", alignItems: "center" }} className='invoice-heading-container'>
        <div
          className="approval-back-image"
          onClick={() => {
            history.push(`/home`)
          }}
        >
          <img
            src={"../../../../assets/images/back-icon.svg"}
            alt="back button"
            className="image-top-wrapper"
          />
        </div>
        <div
          className="Heading"
        >Approval Requests</div>
      </div>
      <div className='pending-component-wrapper'>
        <RMOPendingAppointmentComponent />
      </div>
    </div>
  )
}

export default DiscountApproval